import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import { Alert, Button, Chip, Divider, Tooltip } from "@mui/material";
import close from "../../assets/icons/close.png";
import {
    getApprovalStatusDetails,
    updateApprovalRequestAPI
} from "../Services/OrgRepo";
import { showToast } from "../../Components/Toast";
import Grid from "@mui/material/Grid2";

import {
    accountManager,
    accountManagerHead,
    generatProfilePicUrl,
    getLoggedInUserID
} from "../../Utils/Constant";
import { ThreeDot } from "react-loading-indicators";
import { useEffect } from "react";

interface ApprovalDetails {
    id: number;
    actions: string;
    assignedPerson: string;
    assignedPersonDepartment: string;
    comments: string;
    approvalStatus: string;
    review: string;
    time: string;
    deptHeadID: string;
    partIDs: any;
    profileImage: string;
    deptHeadEmail: string;
    coRfqID: string;
}

export const ApprovalStatusDrawer: React.FC<{
    open: any;
    onClose: any;
    isRfqDateEnd: boolean;
    row: any;
    approvers: any;
    rawRfqID: string;
}> = ({ open, onClose, isRfqDateEnd, approvers, rawRfqID }) => {
    const [openView, setOpenView] = React.useState({});

    const toggleView = (rowId) => {
        setOpenView((prev) => ({
            ...prev,
            [rowId]: !prev[rowId]
        }));
    };

    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isRequestUpdateLoading, setIsRequestUpdateLoading] =
        React.useState<boolean>(false);
    const [rowsGd, setRowsGd] = React.useState<ApprovalDetails[]>([]); // Store as an array

    const fetchApprovalStatusData = async (params: string) => {
        setIsLoading(true);
        try {
            const response = await getApprovalStatusDetails(params);
            if (response?.status && response?.data?.length > 0) {
                const data: ApprovalDetails[] = response?.data?.map(
                    (item: any, index: number) => {
                        const filepath = approvers?.filter((element: any) => {
                            if (element?.profileFileID === item?.deptHeadID) {
                                return element?.profileFileName;
                            }
                        });
                        return {
                            id: index + 1,
                            actions: item?.actions || "-",
                            assignedPerson: item?.assignedPerson || "-",
                            assignedPersonDepartment:
                                item?.assignedPersonDepartment || "-",
                            comments: item?.comments || "-",
                            approvalStatus: item?.approvalStatus || "-",
                            review: item?.review || "-",
                            time: item?.time || "-",
                            deptHeadID: item?.deptHeadID,
                            deptHeadEmail: item?.deptHeadEmail,
                            coRfqID: item?.coRfqID,
                            partIDs: item?.partIDs || [],
                            profileImage: generatProfilePicUrl(
                                item?.deptHeadID,
                                filepath[0]?.profileFileName,
                                "Profile_Picture"
                            )
                        };
                    }
                );
                const sortedData = data?.sort((a, b) => {
                    if (a.review === "Pending" && b.review !== "Pending")
                        return -1;
                    if (a.review !== "Pending" && b.review === "Pending")
                        return 1;
                    return 0;
                });

                setRowsGd(sortedData); // Store the array of data
            } else {
                setRowsGd([]);
            }
        } catch (error) {
            console.log("errrrrrrrrr", error);
        } finally {
            setIsLoading(false);
        }
    };

    const requestUpdateApi = async (params: any) => {
        setIsRequestUpdateLoading(true);
        let payload = {
            requestUpdatedBy: getLoggedInUserID(),
            coRfqID: rowsGd[0]?.coRfqID,
            deptHeadEmail: params?.deptHeadEmail
        };
        try {
            const response = await updateApprovalRequestAPI(payload);
            if (response?.status) {
                showToast({
                    message: `Request update sent to ${params?.assignedPerson}`,
                    type: "success"
                });
                fetchApprovalStatusData(rawRfqID);
            } else {
                showToast({
                    message: response?.message,
                    type: "error"
                });
            }
        } catch (error) {
            console.log(error);
            showToast({
                message: error?.message,
                type: "error"
            });
        } finally {
            setIsRequestUpdateLoading(false);
        }
    };
    useEffect(() => {
        if (open && rawRfqID) {
            fetchApprovalStatusData(rawRfqID);
        }
    }, [open, rawRfqID]);
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ p: 2, width: { xs: "100%", sm: 600 } }}>
                {/* Header Section */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" fontWeight="bold">
                        Approval Status
                    </Typography>
                    <Box>
                        <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                            <img src={close} width={"14px"} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>
                <Divider sx={{ my: 2 }} />

                {!isLoading ? (
                    rowsGd?.map((row, index) => (
                        <>
                            <Alert
                                key={index}
                                severity="success"
                                icon={false}
                                sx={{
                                    display: "inherit",
                                    padding: "6px 10px",
                                    marginBottom: "10px",
                                    background: " #E3F2FD4D",
                                    border: "1px solid #f2f2f2",
                                    color: "#000"
                                }}
                            >
                                <Grid container spacing={2} mb={0}>
                                    <Grid size={{ xs: 9, md: 9 }}>
                                        <Grid container spacing={2} mb={0}>
                                            <Grid size={{ xs: 8, md: 8 }}>
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    mb={0}
                                                >
                                                    <Grid
                                                        size={{ xs: 2, md: 2 }}
                                                    >
                                                        <img
                                                            src={
                                                                row?.profileImage
                                                            }
                                                            alt="logo"
                                                            width={40}
                                                            height={40}
                                                            style={{
                                                                marginRight:
                                                                    "5px",
                                                                borderRadius:
                                                                    "50%"
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        size={{
                                                            xs: 10,
                                                            md: 10
                                                        }}
                                                        pl={1}
                                                    >
                                                        <Typography variant="body2">
                                                            {
                                                                row?.assignedPerson
                                                            }
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                display:
                                                                    "inline-flex"
                                                            }}
                                                        >
                                                            {/*                          
                          <Divider
                            orientation="vertical"
                            sx={{ margin: "0 10px" }}
                            variant="middle"
                            flexItem
                          /> */}
                                                            <Typography
                                                                variant="body2"
                                                                color="text.secondary"
                                                                sx={{
                                                                    fontSize:
                                                                        "0.75rem"
                                                                }}
                                                            >
                                                                {
                                                                    row?.assignedPersonDepartment
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 4, md: 4 }}>
                                                <Tooltip title={row?.review}>
                                                    <Chip
                                                        label={row?.review}
                                                        color={
                                                            row?.review ===
                                                            "Approved"
                                                                ? "success"
                                                                : row?.review ===
                                                                    "Partially Approved"
                                                                  ? "warning"
                                                                  : row?.review ===
                                                                      "Rejected"
                                                                    ? "error"
                                                                    : "default"
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{
                                                            padding: "0 4px",
                                                            marginLeft: "10px",
                                                            ...(row?.review ===
                                                                "Partially Approved" && {
                                                                borderColor:
                                                                    "#F8B714",
                                                                color: "#F8B714"
                                                            }),
                                                            ...(row?.review ===
                                                                "Pending" && {
                                                                border: "1px solid #ccc",
                                                                color: "#797979"
                                                            })
                                                        }}
                                                    />
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={{ xs: 3, md: 3 }}>
                                        {(accountManager() ||
                                            accountManagerHead()) && (
                                            <Button
                                                size="small"
                                                disabled={
                                                    row?.review !== "Pending" ||
                                                    !isRfqDateEnd ||
                                                    isRequestUpdateLoading
                                                }
                                                onClick={() =>
                                                    requestUpdateApi(row)
                                                }
                                            >
                                                <Typography variant="caption">
                                                    {row?.approvalStatus}
                                                </Typography>
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                                {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <img
                        src={row?.profileImage}
                        alt="logo"
                        width={40}
                        height={40}
                        style={{ marginRight: "5px", borderRadius: "50%" }}
                      />
                      <div style={{ lineHeight: "10px", minWidth: "150px" }}>
                        <Typography variant="body2">
                          {row?.assignedPerson}
                        </Typography>
                        <Box
                          sx={{
                            display: "inline-flex",
                          }}
                        >
                          
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: "0.75rem" }}
                          >
                            {row?.assignedPersonDepartment}
                          </Typography>
                        </Box>
                      </div>
                    </div>

                    <div
                      style={{
                        marginLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <Chip
                          label={row?.review}
                          color={
                            row?.review === "Approved"
                              ? "success"
                              : row?.review === "Partially Approved"
                                ? "warning"
                                : row?.review === "Rejected"
                                  ? "error"
                                  : "default"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            padding: "0 4px",
                            marginLeft: "10px",
                            ...(row?.review === "Partially Approved" && {
                              borderColor: "#F8B714",
                              color: "#F8B714",
                            }),
                            ...(row?.review === "Pending" && {
                              border: "1px solid #ccc",
                              color: "#797979",
                            }),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      alignItems: "start",
                      display: "flex",
                      justifyContent: "end",
                      width: "30%",
                    }}
                  >
                    {(accountManager() || accountManagerHead()) && (
                      <Button
                        size="small"
                        disabled={
                          row?.review !== "Pending" ||
                          !isRfqDateEnd ||
                          isRequestUpdateLoading
                        }
                        onClick={() => requestUpdateApi(row)}
                      >
                        {row?.approvalStatus}
                      </Button>
                    )}
                  </div>
                </Box> */}
                                <Box sx={{ marginLeft: "5px" }} mt={1}>
                                    {row?.review !== "Pending" && (
                                        <>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{ fontWeight: "600" }}
                                            >
                                                Reason
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="default"
                                            >
                                                {row?.comments}
                                            </Typography>
                                        </>
                                    )}

                                    {row?.review === "Partially Approved" && (
                                        <>
                                            <Typography
                                                color="primary"
                                                variant="body2"
                                                onClick={() =>
                                                    toggleView(row?.id)
                                                }
                                                sx={{
                                                    mt: 1,
                                                    fontWeight: "600",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                {openView[row?.id]
                                                    ? "Hide Parts"
                                                    : "Show Parts"}
                                            </Typography>
                                            <Collapse in={openView[row?.id]}>
                                                {row?.partIDs?.length > 0 && (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ mt: 1 }}
                                                    >
                                                        {row?.partIDs?.map(
                                                            (item) => (
                                                                <Chip
                                                                    label={
                                                                        item?.partNo +
                                                                        "-" +
                                                                        item?.partName
                                                                    }
                                                                    size="small"
                                                                    sx={{
                                                                        marginRight:
                                                                            "5px",
                                                                        marginBottom:
                                                                            "5px"
                                                                    }}
                                                                />
                                                            )
                                                        )}
                                                    </Typography>
                                                )}
                                            </Collapse>
                                        </>
                                    )}
                                </Box>
                            </Alert>
                        </>
                    ))
                ) : (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="50vh"
                    >
                        <ThreeDot
                            color="#1976d2"
                            size="medium"
                            text=""
                            textColor=""
                        />
                    </Box>
                )}
            </Box>
        </Drawer>
    );
};
